import React from "react";
import { cn } from "../../lib/utils";

export const SectionLabel = ({
  children,
  className,
  noMargin,
}: {
  children: React.ReactNode;
  className?: string;
  noMargin?: boolean;
}) => {
  const margin = noMargin ? "" : "mb-1.5";
  return (
    <p
      className={cn(
        margin + " text-sm font-semibold text-ink-muted",
        className,
      )}
    >
      {children}
    </p>
  );
};
